import { useQueryClient } from '@tanstack/react-query';
import Cookies from 'js-cookie';
import { getDefaultPage, getPageUsernames } from '@linkie/api-client';
import useAuth from '@/modules/auth/hooks/useAuth.hook';
import { usePlaygroundDispatch } from '../store/playground.store';
import { PlaygroundActionType } from '../types/playground-action.type';
import { toPlaygroundPayload } from '../utils/to-playground-payload';

export function usePlaygroundRefetch() {
  const queryClient = useQueryClient();
  const { state: authState } = useAuth();
  const dispatch = usePlaygroundDispatch();
  const userId = authState.user?._id ?? '';

  const refetchPage = async () => {
    const response = await queryClient.fetchQuery({
      queryKey: ['default-page', userId],
      queryFn: () => getDefaultPage(userId),
      staleTime: 0,
    });
    const linkie = response?.data;

    if (!linkie) return;

    dispatch({
      type: PlaygroundActionType.SET_INIT_PAYLOAD,
      payload: toPlaygroundPayload(linkie),
    });

    Cookies.set('pageId', linkie?._id || '');
  };

  const refetchPageUsernames = async () => {
    const response = await queryClient.fetchQuery({
      queryKey: ['page-usernames', userId],
      queryFn: () => getPageUsernames(userId),
      staleTime: 0,
    });

    if (!response) return;

    dispatch({
      type: PlaygroundActionType.GET_LINKIE_USERNAMES,
      payload: response.data,
    });
  };

  return { refetchPage, refetchPageUsernames };
}
